import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { IDatePickerConfig, IDatePickerToastText } from "mis-crystal-design-system/datepicker_v2";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { parseZone, min } from "moment";
import { take } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "mis-employee-web-exp-recurrence-booking-form",
  templateUrl: "./recurrence-booking-form.component.html",
  styleUrls: ["./recurrence-booking-form.component.scss"]
})
export class RecurrenceBookingFormComponent implements OnInit {
  @Input() dpConfig: Partial<IDatePickerConfig>;
  @Input() datesDisabled: string[];
  @Input() dateMessages: IDatePickerToastText[];
  @Input() recurrenceFormGroup: AbstractControl;
  @Input() maxDuration: number;
  @Input() weeklyOffs: number[] = [];

  errorInput = false;
  disableDay = false;
  private endObs = new Subject<void>();
  days: string[] = ["M", "T", "W", "T", "F", "S", "S"];
  daysFull: string[] = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  daysIndex: number[] = [1, 2, 3, 4, 5, 6, 7];
  selectedDays: Set<number> = new Set();
  selectedOption: number = -1;
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;

  constructor() {}

  ngOnInit(): void {
    this.dpConfig = JSON.parse(JSON.stringify(this.dpConfig));
    if (this.weeklyOffs.length) {
      this.weeklyOffs = this.weeklyOffs.map(item => {
        if (item === 1) item = 7;
        else item = item - 1;
        return item;
      });
    }
    this.dpConfig.minDate = parseZone(this.dpConfig.minDate, this.dpConfig.format).tz(this.dpConfig.timezone).format(this.dpConfig.format);
    this.dpConfig.maxDate = parseZone().add(this.maxDuration, "days").tz(this.dpConfig.timezone).format(this.dpConfig.format);
    this.radioEventHandler(0); // for initial selection of first radio button
    this.daysIndex.map(item => this.toggleWorkingDay(item));
  }
  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }
  toggleWorkingDay(day: number): void {
    if (this.selectedDays.has(day)) {
      this.selectedDays.delete(day);
    } else if (!this.weeklyOffs.includes(day)) {
      this.selectedDays.add(day);
      this.disableDay = false;
    } else {
      this.disableDay = true;
    }
    this.recurrenceFormGroup.get("repeatsEvery").patchValue({ days: this.rruleDaysArrayHandler(Array.from(this.selectedDays)) }, { onlySelf: false });
  }
  rruleDaysArrayHandler(days) {
    if (days) {
      days = days.map(item => (item % 7) + 1);
    }
    return days;
  }

  radioEventHandler(id: number) {
    const repeatsEvery = this.recurrenceFormGroup.get("repeatsEvery") as FormGroup;
    this.selectedOption = id;
    if (this.selectedOption === 1) {
      repeatsEvery.get("repeatedDay").enable();
      repeatsEvery.get("days").disable();
    } else {
      repeatsEvery.get("repeatedDay").disable();
      repeatsEvery.get("days").enable();
    }
  }
}
